const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/pages/DashboardPage/Components/appointmentCards/styles.ts';
import { css } from '@emotion/css';
import { theme } from 'App/utils/clientSetupManager';

export const labelCellStyle = css`
    grid-column: 1;
    margin-top: ${theme.spacing(1)};
    white-space: nowrap;
    margin-right: ${theme.spacing(2)};
`;

export const textCellStyle = css`
    grid-column: 2;
    margin-top: ${theme.spacing(1)};
`;

export const geoCellStyle = css`
    grid-column: 2;
    margin-top: ${theme.spacing(1)};
    color: ${theme.palette.primary.main};
`;

export const styleIcon: any = {
    color: theme.palette.primary.main,
};

export const fullWidth = css`
    width: 100%;
`;

export const cardContentWithIconColumnClass = css`
    display: flex;
    flex-direction: row;
    gap: ${theme.spacing(1)};

    > *:first-child {
        flex: none;
    }

    > *:last-child {
        flex: auto;
    }
`;

export const headerIconStyle = css`
    margin-top: ${theme.spacing(1)};
    color: ${theme.palette.primary.main};
`;

export const appointmentCardSubtitleStyle = css`
    font-weight: 400;
    font-size: 1.5rem;
`;

export const flexRow = css`
    display: flex;
    justify-content: space-between;
    align-items: center;
`;

export const linkStyle = css`
    text-decoration: none;
    color: ${theme.palette.primary.main};
`;

export const noAppointmentTextCss = css`
    margin: 0;
`;

export const gridStyle = css`
    display: grid;
    grid-template-columns: min-content auto; // or use: auto 1fr
    margin-top: ${theme.spacing(1)};
    margin-bottom: ${theme.spacing(1)};
    max-height: 100%;
`;

export const noAppointmentTextStyle = css`
    padding: ${theme.spacing(2)} ${theme.spacing(0)};
`;
